import { request } from './index'

const baseUrl = '//wuji.video.qq.com/fcgi-bin/wuji'

export default {
  getEggList () {
    return request({
      url: baseUrl,
      data: {
        appid: '1000548',
        appkey: '0abac4998f204fae9bba89cca7b8dac2',
        filter: 'is_valid%3dtrue',
        size: 1000
      }
    })
  },

  getBanner () {
    return request({
      url: baseUrl,
      data: {
        appid: '1000550',
        appkey: '9b35e4f1277e4e859f56873fab8a15bd',
        filter: 'is_valid%3dtrue'
      }
    })
  }
}
